export const CONSTS = {
  ERROR_TEXT_1: 'User %s does not have access to GPD',
  ERROR_TEXT_2:
    'To request rights, please contact your region coordinator using the link below',
};
